import { render, staticRenderFns } from "./StoreConfirm.vue?vue&type=template&id=d16d62f6&"
import script from "./StoreConfirm.vue?vue&type=script&lang=js&"
export * from "./StoreConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports